import io from "socket.io-client";
import { CHAT_URL } from "../constants/app";

const socket = io(CHAT_URL); // URL du service de chat

export default socket